<div class="w-full max-w-4xl mx-auto">
  
  <!-- Header -->
  <div class="mb-6">
    <div class="flex items-center gap-4 mb-2">
      <button 
        mat-icon-button 
        (click)="goBack()"
        matTooltip="Wróć do listy ogłoszeń"
        class="!text-gray-600 dark:!text-gray-400">
        <mat-icon [svgIcon]="'tabler_outline:arrow-left'"></mat-icon>
      </button>
      <div>
        <h1 class="text-3xl font-bold text-gray-900 dark:text-white">
          {{ mode === 'create' ? 'Nowe ogłoszenie' : 'Edycja ogłoszenia' }}
        </h1>
        <p class="text-gray-600 dark:text-gray-400 mt-1">
          {{ mode === 'create' ? 'Utwórz nowe ogłoszenie systemowe' : 'Zaktualizuj informacje o ogłoszeniu' }}
        </p>
      </div>
    </div>
  </div>

  <!-- Loading state -->
  <div *ngIf="isLoading" class="flex items-center justify-center py-20">
    <mat-spinner diameter="50"></mat-spinner>
  </div>

  <!-- Form -->
  <div *ngIf="!isLoading" class="bg-card rounded-2xl shadow-lg overflow-hidden">
    
    <!-- Form content -->
    <div class="p-6">
      <form [formGroup]="form">
        
        <!-- Title field -->
        <mat-form-field appearance="outline" class="w-full mb-4">
          <mat-label>Tytuł ogłoszenia</mat-label>
          <input 
            type="text" 
            matInput 
            formControlName="title"
            placeholder="Wprowadź tytuł ogłoszenia">
          <mat-icon matPrefix [svgIcon]="'tabler_outline:heading'" class="text-gray-500"></mat-icon>
          <mat-error *ngIf="form.controls.title.hasError('required')">
            Tytuł jest wymagany
          </mat-error>
          <mat-error *ngIf="form.controls.title.hasError('minlength')">
            Tytuł musi mieć minimum 3 znaki
          </mat-error>
          <mat-hint>Min. 3 znaki</mat-hint>
        </mat-form-field>

        <!-- Description field -->
        <mat-form-field appearance="outline" class="w-full mb-4">
          <mat-label>Treść ogłoszenia</mat-label>
          <textarea 
            matInput 
            formControlName="description"
            placeholder="Wprowadź treść ogłoszenia"
            rows="6"
            cdkTextareaAutosize
            #autosize="cdkTextareaAutosize"
            cdkAutosizeMinRows="6"
            cdkAutosizeMaxRows="15"></textarea>
          <mat-icon matPrefix [svgIcon]="'tabler_outline:file-text'" class="text-gray-500"></mat-icon>
          <mat-error *ngIf="form.controls.description.hasError('required')">
            Treść jest wymagana
          </mat-error>
          <mat-error *ngIf="form.controls.description.hasError('minlength')">
            Treść musi mieć minimum 10 znaków
          </mat-error>
          <mat-hint>Min. 10 znaków</mat-hint>
        </mat-form-field>

        <!-- Active toggle -->
        <div class="mb-6">
          <div class="flex items-center justify-between p-4 bg-gray-50 dark:bg-gray-800 rounded-xl">
            <div class="flex items-center gap-3">
              <div class="p-2 bg-primary-100 dark:bg-primary-900/30 rounded-lg">
                <mat-icon 
                  class="text-primary-600 dark:text-primary-400" 
                  [svgIcon]="'tabler_outline:bell'">
                </mat-icon>
              </div>
              <div>
                <p class="font-semibold text-gray-900 dark:text-white">Status ogłoszenia</p>
                <p class="text-sm text-gray-600 dark:text-gray-400">
                  {{ form.controls.isActive.value ? 'Ogłoszenie jest widoczne dla użytkowników' : 'Ogłoszenie jest ukryte' }}
                </p>
              </div>
            </div>
            <mat-slide-toggle 
              formControlName="isActive"
              color="primary"
              class="ml-4">
              {{ form.controls.isActive.value ? 'Aktywne' : 'Nieaktywne' }}
            </mat-slide-toggle>
          </div>
        </div>

      </form>
    </div>

    <!-- Actions -->
    <div class="p-6 bg-gray-50 dark:bg-gray-800 border-t dark:border-gray-700 flex items-center justify-between gap-4">
      
      <!-- Left side - Delete button (only in update mode) -->
      <div>
        <button 
          *ngIf="mode === 'update'"
          mat-button
          color="warn"
          (click)="remove()"
          [disabled]="isDeleting || isSaving"
          class="!rounded-lg">
          <mat-spinner *ngIf="isDeleting" diameter="20" class="mr-2"></mat-spinner>
          <mat-icon *ngIf="!isDeleting" [svgIcon]="'tabler_outline:trash'" class="mr-2"></mat-icon>
          {{ isDeleting ? 'Usuwanie...' : 'Usuń ogłoszenie' }}
        </button>
      </div>

      <!-- Right side - Cancel and Save buttons -->
      <div class="flex items-center gap-3">
        <button 
          mat-stroked-button
          (click)="goBack()"
          [disabled]="isSaving || isDeleting"
          class="!rounded-lg">
          <mat-icon [svgIcon]="'tabler_outline:x'" class="mr-2"></mat-icon>
          Anuluj
        </button>

        <button 
          *ngIf="mode === 'create'"
          mat-raised-button 
          color="primary"
          (click)="create()"
          [disabled]="isSaving || isDeleting"
          class="!rounded-lg">
          <mat-spinner *ngIf="isSaving" diameter="20" class="mr-2"></mat-spinner>
          <mat-icon *ngIf="!isSaving" [svgIcon]="'tabler_outline:plus'" class="mr-2"></mat-icon>
          {{ isSaving ? 'Tworzenie...' : 'Utwórz ogłoszenie' }}
        </button>

        <button 
          *ngIf="mode === 'update'"
          mat-raised-button 
          color="primary"
          (click)="save()"
          [disabled]="isSaving || isDeleting"
          class="!rounded-lg">
          <mat-spinner *ngIf="isSaving" diameter="20" class="mr-2"></mat-spinner>
          <mat-icon *ngIf="!isSaving" [svgIcon]="'tabler_outline:device-floppy'" class="mr-2"></mat-icon>
          {{ isSaving ? 'Zapisywanie...' : 'Zapisz zmiany' }}
        </button>
      </div>

    </div>

  </div>

</div>